module.exports = __webpack_public_path__ + "img/kemenhub-logo.8f8e80a1.svg";